export enum EnumTipoDeOrigem {
  Cadastrado = 'cadastrado',
  ImportadoCsv = 'csv',
  ImportadoIfood = 'ifood',
  ImportadoIfoodApi = 'ifoodapi',
  ImportadoAnotaAi = 'anotaai',
  ImportadoOlaclick = 'olaclick',
  ImportadoCardapioWeb = 'cardapioweb',
  ImportadoCardapioAi = 'cardapioai',
  ImportadoGoomer = 'goomer',
  ImportadoUaiRango = 'uairango',
  ImportadoKeeta = 'keeta',
  Importado99Food = '99food',
  ImportadoEcletica = 'ecletica',
  ImportadoBluesoft = 'bluesoft',
  ImportadoSaipos = 'saipos',
  ImportadoMenew = 'menew',
  ImportadoColibri = 'colibri',
  ImportadoRPInfo = 'rpinfo',
  ImportadoChinaInBox = 'chinainbox',
  ImportadoTeknisa= 'teknisa',
  ImportadoGcom = 'gcom',
  ImportadoOpenDelivery= 'opendelivery',
  ImportadoAiqFome = 'aiqfome',
  ImportadoInstaDelivery = 'instadelivery',
  ImportadoMenuDino = 'menudino',
  ImportadoDeliveryDireto = 'deliverydireto',
  ImportadoTakeat = 'takeat',
  ImportadoYooga = 'yooga',
  ImportadoPedirDelivery = 'pedirdelivery',
  ImportadoPecaqui = 'pecaqui',
  ImportadoLiveMenu = 'livemenu',
  ImportadoWhatsMenu = 'whatsmenu',
  ImportadoBrendi = 'brendi',
  ImportadoMeuCardapio = 'meucardapio',
  ImportadoCardapioPorIA = 'importadoia',
}
